/**
 * Static LSQ config strings — mirrors Android Remote Config keys
 * `R.string.unified_new_lsq_config_debug` / `R.string.unified_new_lsq_config`.
 *
 * Replace the JSON with values from Firebase Remote Config (same payload Gson uses on Android).
 * Placeholder schema maps attribute → itself for local smoke tests; production needs real LSQ codes.
 */
export const unified_new_lsq_config_debug = JSON.stringify({
    access_key: "AKIA2R2EX7PZKWD4DFUR",
    secret_key: "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",
    queue_url: "https://sqs.ap-south-1.amazonaws.com/725456780274/LSQ-learn-queue",
    signup_queue_url: "https://sqs.ap-south-1.amazonaws.com/725456780274/PROD-website-queue",
    testing_queue_url: "https://sqs.ap-south-1.amazonaws.com/725456780274/PREPROD-Learn-queue",
    productVerticalMap: {
        "1": "Learn",
        "2": "SCA",
        "3": "Schools",
        "4": "Meta",
    },
    androidConfig: {
        verticalIds: [1],
        isdCode: ["91"],
        isTriggerForPaidUser: false,
    },
    isLSQEnabled: true,
    schemas: {
        Act_Tests: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            tests_score: "mx_Custom_1",
            studentName: "mx_Custom_2",
            tests_rank: "mx_Custom_3",
            userType: "mx_Custom_4",
            unifiedAccountID: "mx_Custom_5",
            reportURL: "mx_Custom_7",
            tests_test_name: "mx_Custom_8",
            tests_exam_type: "mx_Custom_10",
            productVertical: "mx_Custom_11",
            tests_subject: "mx_Custom_13",
            percentage: "mx_Custom_14",
            testDate: "mx_Custom_15",
            testMode: "mx_Custom_16",
            grade: "mx_Custom_21",
            platform: "mx_Custom_22",
            test_mode: "mx_Custom_20",
        },
        Act_Master_Class_App: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            recorded_class: "mx_Custom_1",
            className: "mx_Custom_2",
            watchTimeInSeconds: "mx_Custom_3",
            subject: "mx_Custom_4",
            facultyName: "mx_Custom_8",
            studentName: "mx_Custom_9",
            userType: "mx_Custom_10",
            unifiedAccountID: "mx_Custom_11",
            productVertical: "mx_Custom_12",
            grade: "mx_Custom_13",
            platform: "mx_Custom_14",
        },
        Act_Doubts: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            doubtsSubject: "mx_Custom_2",
            studentName: "mx_Custom_6",
            userType: "mx_Custom_7",
            unifiedAccountId: "mx_Custom_8",
            productVertical: "mx_Custom_9",
            grade: "mx_Custom_10",
            platform: "mx_Custom_11",
        },
        ACT_TALK_TO_EXPERT: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            requestedDate: "mx_Custom_1",
            studentName: "mx_Custom_2",
            phone: "mx_Custom_4",
            preferableDateTime: "mx_Custom_6",
            attendee: "mx_Custom_7",
            language: "mx_Custom_8",
            remarks: "mx_Custom_10",
            decisionMaker: "mx_Custom_11",
            examName: "mx_Custom_12",
            grade: "mx_Custom_13",
            parentOrStudent: "mx_Custom_14",
            intentOfTheStudent: "mx_Custom_15",
            interestInOnlineCoaching: "mx_Custom_16",
            howDoYouStudyOnline: "mx_Custom_17",
            difficultSubjectForStudent: "mx_Custom_18",
            preferredLearningMode: "mx_Custom_19",
            schoolName: "mx_Custom_20",
            inMobiusSchoolCode: "mx_Custom_21",
            latitudeLong: "mx_Custom_22",
            platform: "mx_Custom_25",
            attendingPerson: "mx_Custom_26",
            userType: "mx_Custom_27",
            unifiedAccountId: "mx_Custom_28",
            productVertical: "mx_Custom_29",
        },
        Act_Self_Learn_Flashcards: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            flashcard_subject: "mx_Custom_1",
            flashcard_chapter: "mx_Custom_2",
            firstName: "mx_Custom_3",
            userType: "mx_Custom_4",
            unifiedAccountID: "mx_Custom_5",
            productVertical: "mx_Custom_6",
            grade: "mx_Custom_7",
            platform: "mx_Custom_8",
        },
        Act_Self_Learn_Video: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            studyVideo: "mx_Custom_1",
            durationWatched: "mx_Custom_2",
            subject: "mx_Custom_3",
            chapter: "mx_Custom_4",
            studentName: "mx_Custom_5",
            userType: "mx_Custom_6",
            unifiedAccountId: "mx_Custom_7",
            productVertical: "mx_Custom_8",
            grade: "mx_Custom_9",
            platform: "mx_Custom_10",
        },
        Act_Self_Learn_Story: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            story_subject: "mx_Custom_1",
            story_chapter: "mx_Custom_2",
            studentName: "mx_Custom_3",
            userType: "mx_Custom_4",
            unifiedAccountID: "mx_Custom_5",
            productVertical: "mx_Custom_6",
            grade: "mx_Custom_7",
            platform: "mx_Custom_8",
        },
        Act_Score: {
            score_exam_type: "mx_Custom_1",
            score_target_exam: "mx_Custom_2",
            score_exam_date: "mx_Custom_3",
            score_time_slot: "mx_Custom_4",
            score_mode_of_exam: "mx_Custom_5",
            score_grade: "mx_Custom_6",
            score_email_id: "mx_Custom_7",
            score_address: "mx_Custom_8",
        },
        Act_Payments: {
            referral_sale_from_student: "mx_Custom_1",
            payment_date_if_paid: "mx_Custom_2",
            package_name_if_paid: "mx_Custom_3",
            amount_paid_in_rupees: "mx_Custom_4",
        },
        ACT_unlock_doubts: {
            coins_used: "mx_Custom_1",
            unlocked: "mx_Custom_2",
            count: "mx_Custom_3",
        },
        ACT_extend_validity: {
            coins_used: "mx_Custom_1",
            unlocked: "mx_Custom_2",
            count: "mx_Custom_3",
        },
        ACT_unlock_discount: {
            coins_used: "mx_Custom_1",
            unlocked: "mx_Custom_2",
            discount_availed: "mx_Custom_3",
        },
        ACT_unlock_selflearn: {
            coins_used: "mx_Custom_1",
            unlocked: "mx_Custom_2",
            count: "mx_Custom_3",
        },
        Act_Refferal: {
            reffered_by: "mx_Custom_1",
            reffer_contact: "mx_Custom_2",
        },
        Act_Live_Class_Playlist: {
            playlist_name: "mx_Custom_1",
            video_name: "mx_Custom_2",
            subject: "mx_Custom_3",
            duration_of_video: "mx_Custom_4",
        },
        Act_RedeemCoins_Unlock_MockTest: {
            coins_used_to_redeem: "mx_Custom_1",
            unlocked: "mx_Custom_2",
            count_of_mock_test_unlocked: "mx_Custom_3",
        },
        Act_WIT_Test_Started: {
            Event_date_Time: "mx_Custom_1",
        },
        Act_WIT_Test_Completed: {
            questions_answered: "mx_Custom_1",
            correct_answers: "mx_Custom_2",
            time_taken: "mx_Custom_3",
            total_assessment_time: "mx_Custom_4",
        },
        Act_WIT_Test_Report: {
            report: "mx_Custom_1",
        },
        Act_WIT_Test_Certificate: {
            certificate: "mx_Custom_1",
        },
        ACT_score_ordercreated: {
            target_exam: "mx_Custom_1",
            mode_of_exam: "mx_Custom_2",
            grade: "mx_Custom_3",
            address: "mx_Custom_4",
            organisation: "mx_Custom_5",
            platform: "mx_Custom_6",
        },
        ACT_marketing: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            utmUrl: "mx_Custom_1",
            utmSource: "mx_Custom_2",
            utmCampaign: "mx_Custom_3",
            utmMedium: "mx_Custom_4",
            utmContent: "mx_Custom_5",
            utmId: "mx_Custom_6",
            utmTerm: "mx_Custom_7",
            grade: "mx_Custom_11",
            examName: "mx_Custom_12",
            referralPage: "mx_Custom_13",
            productVertical: "mx_Custom_17",
            parentOrStudent: "mx_Custom_18",
            studentName: "mx_Custom_19",
            userType: "mx_Custom_20",
            unifiedAccountId: "mx_Custom_21",
            platform: "mx_Custom_22",
        },
        ACT_set_goal: {
            grade: "mx_Custom_1",
            target_exam: "mx_Custom_2",
            target_aim: "mx_Custom_3",
            target_college: "mx_Custom_4",
        },
        ACT_score_Attemptnow: {
            entity: "mx_Custom_1",
            Status: "Status",
        },
        ACT_score_exam_submit: {
            type: "mx_Custom_1",
            exam: "mx_Custom_2",
            examdate: "mx_Custom_3",
            time_slot: "mx_Custom_4",
            mode: "mx_Custom_5",
            grade: "mx_Custom_6",
            email: "mx_Custom_7",
            address: "mx_Custom_8",
            score: "mx_Custom_9",
            mx_custom_10: "mx_Custom_10",
            ffedback1: "mx_Custom_11",
            feedback2: "mx_Custom_12",
            coupon_code: "mx_Custom_13",
            city: "mx_Custom_14",
            school_name: "mx_Custom_15",
            state: "mx_Custom_16",
            examstated: "mx_Custom_17",
            exam_submittd: "mx_Custom_18",
            time_of_exam_attemed: "mx_Custom_19",
            time_of_exam_submitted: "mx_Custom_20",
            interested_in: "mx_Custom_21",
            mx_Custom_22: "mx_Custom_22",
            entity: "mx_Custom_23",
            district: "mx_Custom_24",
            report_link: "mx_Custom_25",
            certificate_link: "mx_Custom_26",
            exam_type: "mx_Custom_27",
            percentage: "mx_Custom_28",
        },
        ACT_PaymentSuccess: {
            orderAmount: "mx_Custom_1",
            discountAmount: "mx_Custom_2",
            paidAmount: "mx_Custom_3",
            currency: "mx_Custom_4",
            paymentDateTime: "mx_Custom_5",
            paymentPlatform: "mx_Custom_6",
            paymentGateway: "mx_Custom_7",
            paymentType: "mx_Custom_8",
            gatewayPaymentId: "mx_Custom_9",
            gatewayOrderId: "mx_Custom_10",
            billingEmail: "mx_Custom_11",
            billingPhone: "mx_Custom_12",
            state: "mx_Custom_13",
            InvoiceId: "mx_Custom_14",
            taxAmount: "mx_Custom_15",
            nextPaymentDueDate: "mx_Custom_16",
            packageName: "mx_Custom_17",
            packageType: "mx_Custom_18",
            packageValidity: "mx_Custom_19",
        },
        ACT_ScoreRegistrationStarted: {
            notes: "ActivityEvent_Note",
            state: "mx_Custom_2",
            city: "mx_Custom_3",
            district: "mx_Custom_4",
            pinCode: "mx_Custom_5",
        },
        ACT_ScoreRegisterForExam: {
            notes: "ActivityEvent_Note",
            entity: "mx_Custom_1",
            centreCity: "mx_Custom_2",
            centreState: "mx_Custom_3",
            centreDistrict: "mx_Custom_4",
            selectedExamCentre: "mx_Custom_5",
            preferredExamDate: "mx_Custom_6",
            timeSlot: "mx_Custom_7",
        },
        ACT_SignUp: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            studentName: "mx_Custom_1",
            grade: "mx_Custom_2",
            examName: "mx_Custom_3",
            state: "mx_Custom_4",
            city: "mx_Custom_5",
            utmUrl: "mx_Custom_6",
            utmSource: "mx_Custom_7",
            utmCampaign: "mx_Custom_8",
            utmMedium: "mx_Custom_9",
            utmContent: "mx_Custom_10",
            utmId: "mx_Custom_11",
            utmTerm: "mx_Custom_12",
            referralPage: "mx_Custom_13",
            productVertical: "mx_Custom_14",
            parentOrStudent: "mx_Custom_15",
            userType: "mx_Custom_16",
            unifiedAccountId: "mx_Custom_17",
            platform: "mx_Custom_18",
        },
        Lead: {
            searchBy: "SearchBy",
            userPhoneNumber: "Phone",
            userFullName: "FirstName",
            firstName: "FirstName",
            lastName: "LastName",
            userEmail: "EmailAddress",
            mxUnifiedAccountID: "mx_Unified_Account_ID",
            unifiedAccountID: "Unified Account ID",
            academicGrade: "mx_Grade",
            productOrLeadOrigin: "Source",
            utmCampaign: "SourceCampaign",
            utmMedium: "SourceMedium",
            utmTerm: "mx_SourceTerm",
            utmContent: "SourceContent",
            pageURL: "mx_Actual_source_URL",
            state: "mx_State",
            city: "mx_City",
            deviceInfoObject: "mx_Mobile_device",
            networkType: "mx_Network_Type",
            productName: "mx_ProductSource",
            stateCode: "mx_State_Code",
            stateName: "mx_State_Name",
            country: "mx_Country",
            primaryTargetExam: "mx_Primary_Target_Exam",
            emailAddress: "EmailAddress",
            centreState: "mx_Centre_State",
            centreCity: "mx_Centre_City",
            centerPinCode: "mx_PinCode",
            centreName: "mx_Centre_Name",
            testDate: "mx_Test_Date",
            schoolName: "mx_School_Name",
            futureAmbition: "mx_Opportunity_Name",
            entity: "mx_Business_Unit",
            optInDate: "mx_Last_Consent_Date",
            sourceIpAddress: "mx_IP_Address",
            mxEnvStagingOrProduction: "mx_Env_Staging_or_Production",
            mxCarLink: "mx_Car_Link",
            mxCertificate: "mx_Certificate",
            mxTestDate: "mx_Test_Date",
            mxDevice: "mx_device",
            mxStudentLoginID: "mx_Student_Login_ID",
            mxInmobiusSchoolCode: "mx_Inmobius_School_Code",
            mxBoard: "mx_Board",
            mxInmobiusSchoolAddress: "mx_Inmobius_School_Address",
            mxDistrict: "mx_District",
            mxFees: "mx_Fees",
            mxTier: "mx_Tier",
            mxCategory: "mx_Category",
            prospect_id: "prospect_id",
        },
        App_Install: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            platform: "mx_Custom_1",
            deviceCategory: "mx_Custom_2",
            deviceBrand: "mx_Custom_3",
            deviceModel: "mx_Custom_4",
            deviceOS: "mx_Custom_5",
            deviceOSVersion: "mx_Custom_6",
            country: "mx_Custom_7",
            state: "mx_Custom_8",
            city: "mx_Custom_9",
            appID: "mx_Custom_10",
            appVersion: "mx_Custom_11",
            appInstallStore: "mx_Custom_12",
            appInstallSource: "mx_Custom_13",
            GCLID: "mx_Custom_14",
            gaCampaignID: "mx_Custom_15",
            gaCampaignName: "mx_Custom_16",
            gaAdGroupID: "mx_Custom_17",
            gaAdGroupName: "mx_Custom_18",
            utmSource: "mx_Custom_19",
            utmMedium: "mx_Custom_20",
            utmCampaign: "mx_Custom_21",
            utmTerm: "mx_Custom_22",
            utmContent: "mx_Custom_23",
            campaignID: "mx_Custom_24",
            campaignName: "mx_Custom_25",
            adGroupID: "mx_Custom_26",
            adGroupName: "mx_Custom_27",
            adID: "mx_Custom_28",
            adName: "mx_Custom_29",
        },
        ActScoreRegistration: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            studentName: "mx_Custom_1",
            grade: "mx_Custom_2",
            examName: "mx_Custom_3",
            testName: "mx_Custom_4",
            utmUrl: "mx_Custom_5",
            productVertical: "mx_Custom_6",
            userType: "mx_Custom_7",
            unifiedAccountId: "mx_Custom_8",
            platform: "mx_Custom_9",
        },
        ActAddToCart: {
            notes: "ActivityEvent_Note",
            status: "Status",
            owner: "Owner",
            packageAmountRs: "mx_Custom_1",
            discountAmountRs: "mx_Custom_2",
            orderAmountRs: "mx_Custom_3",
            orderDateTime: "mx_Custom_4",
            paymentPlatform: "mx_Custom_5",
            couponCode: "mx_Custom_6",
            orderId: "mx_Custom_7",
            packageName: "mx_Custom_8",
            packageValidity: "mx_Custom_9",
            billingPhoneNumber: "mx_Custom_10",
            billingName: "mx_Custom_11",
            billingEmail: "mx_Custom_12",
            studentName: "mx_Custom_13",
            userType: "mx_Custom_14",
            unifiedAccountId: "mx_Custom_15",
            productVertical: "mx_Custom_16",
            grade: "mx_Custom_17",
            platform: "mx_Custom_18",
        },
        GeniusUserLogin: {
            loginUrl: "mx_Custom_1",
            Learn: "mx_Custom_3",
            Latitude: "mx_Custom_4",
            Longitude: "mx_Custom_5",
            IpAddress: "mx_Custom_6",
            utmSource: "mx_Custom_4",
            utmCampaign: "mx_Custom_5",
        },
        InMobiusOnlineTest: {
            loginUrl: "mx_Custom_1",
            onlineOrOffline: "mx_Custom_2",
            studentName: "mx_Custom_3",
            grade: "mx_Custom_4",
            userName: "mx_Custom_5",
            learn: "mx_Custom_6",
            schoolName: "mx_Custom_7",
            city: "mx_Custom_8",
            district: "mx_Custom_9",
            state: "mx_Custom_10",
            country: "mx_Custom_11",
            platform: "mx_Custom_13",
            percentage: "mx_Custom_14",
            marksObtained: "mx_Custom_15",
            totalMarks: "mx_Custom_16",
            correctAnswers: "mx_Custom_17",
            inCorrectAnswers: "mx_Custom_18",
            incorrectAnswers: "mx_Custom_18",
            questionsAnswered: "mx_Custom_19",
            reportUrl: "mx_Custom_20",
            certificateUrl: "mx_Custom_21",
            round: "mx_Custom_22",
            prelims: "mx_Custom_23",
            ipAddress: "mx_Custom_27",
            latLong: "mx_Custom_28",
        },
        GeniusUserLoginEventId: {
            loginUrl: "mx_Custom_1",
            source: "mx_Custom_3",
            latitude: "mx_Custom_4",
            longitude: "mx_Custom_5",
            ipAddress: "mx_Custom_6",
            utmSource: "mx_Custom_7",
            utmCampaign: "mx_Custom_8",
        },
        InMobiusOnlineTestEventId: {
            testName: "mx_Custom_1",
            mode: "mx_Custom_2",
            studentName: "mx_Custom_3",
            grade: "mx_Custom_4",
            username: "mx_Custom_5",
            source: "mx_Custom_6",
            schoolName: "mx_Custom_7",
            city: "mx_Custom_8",
            district: "mx_Custom_9",
            state: "mx_Custom_10",
            country: "mx_Custom_11",
            schoolFees: "mx_Custom_12",
            platform: "mx_Custom_13",
            percentage: "mx_Custom_14",
            marksObtained: "mx_Custom_15",
            totalMarks: "mx_Custom_16",
            correctAnswers: "mx_Custom_17",
            incorrectAnswers: "mx_Custom_18",
            questionsAnswered: "mx_Custom_19",
            reportUrl: "mx_Custom_20",
            certificateUrl: "mx_Custom_21",
            round: "mx_Custom_22",
            examType: "mx_Custom_23",
            repName: "mx_Custom_24",
            managerName: "mx_Custom_25",
            srManagerName: "mx_Custom_26",
            ipAddress: "mx_Custom_27",
            latLong: "mx_Custom_28",
            employeeCode: "mx_Custom_29",
        },
        GeniusPhoneLink: {
            loginUrl: "mx_Custom_1",
            source: "mx_Custom_2",
            unifiedAccountId: "mx_Custom_3",
        },
    },
    eventIds: {
        Act_Master_Class_App: "262",
        Act_Doubts: "267",
        Act_Tests: "261",
        ACT_TALK_TO_EXPERT: "266",
        Act_Self_Learn_Flashcards: "263",
        Act_Self_Learn_Video: "264",
        Act_Self_Learn_Story: "265",
        Act_Score: "269",
        Act_Signin: "213",
        Act_Payments: "254",
        Act_Refferal: "279",
        Act_Live_Class_Playlist: "280",
        Act_RedeemCoins_Unlock_MockTest: "281",
        Act_WIT_Test_Started: "286",
        Act_WIT_Test_Completed: "287",
        Act_WIT_Test_Report: "288",
        Act_WIT_Test_Certificate: "289",
        ACT_unlock_doubts: "282",
        ACT_extend_validity: "283",
        ACT_unlock_selflearn: "284",
        ACT_unlock_discount: "285",
        ACT_score_ordercreated: "314",
        ACT_marketing: "255",
        ACT_set_goal: "317",
        ACT_score_Attemptnow: "234",
        ACT_score_exam_submit: "272",
        ACT_PaymentSuccess: "324",
        ACT_ScoreRegistrationStarted: "228",
        ACT_ScoreRegisterForExam: "212",
        ACT_SignUp: "356",
        App_Install: "231",
        ActScoreRegistration: "286",
        ActAddToCart: "287",
        GeniusUserLoginEventId: "213",
        InMobiusOnlineTestEventId: "254",
        GeniusPhoneLink: "313",
    },
});
export const unified_new_lsq_config = unified_new_lsq_config_debug;
